import { render, staticRenderFns } from "./BtnDelete.vue?vue&type=template&id=6f6453e2&scoped=true&lang=pug"
import script from "./BtnDelete.vue?vue&type=script&lang=js"
export * from "./BtnDelete.vue?vue&type=script&lang=js"
import style0 from "./BtnDelete.vue?vue&type=style&index=0&id=6f6453e2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6453e2",
  null
  
)

export default component.exports